import {BaseComponent} from '../base/component.base.js';
import template from './confirm-dialog.template.html';
import styles from './confirm-dialog.styles.css';

export class ConfirmDialogComponent extends BaseComponent {
    #pendingResolve = null;

    connectedCallback() {
        this.loadTemplate(template, styles);
        const dialog = this.$('#dialog');
        const cancelBtn = this.$('#btn-cancel');

        cancelBtn.addEventListener('click', () => {
            this.#resolve(false);
            dialog.close();
        });

        dialog.addEventListener('close', () => {
            this.#resolve(false);
        });

        this.$('.confirm-dialog-form').addEventListener('submit', () => {
            this.#resolve(true);
        });

        dialog.addEventListener('click', (e) => {
            if (e.target === dialog) {
                dialog.close();
            }
        });
    }

    /**
     * @param {{title: string, body: string, confirmLabel?: string, cancelLabel?: string, danger?: boolean}} options
     * @returns {Promise<boolean>}
     */
    ask(options) {
        const dialog = this.$('#dialog');
        const titleEl = this.$('#dialog-title');
        const bodyEl = this.$('#dialog-body');
        const cancelBtn = this.$('#btn-cancel');
        const confirmBtn = this.$('#btn-confirm');

        titleEl.textContent = options.title;
        bodyEl.textContent = options.body;
        cancelBtn.textContent = options.cancelLabel ?? 'Cancel';
        confirmBtn.textContent = options.confirmLabel ?? 'Confirm';
        dialog.classList.toggle('is-danger', Boolean(options.danger));

        if (this.#pendingResolve) {
            this.#pendingResolve(false);
            this.#pendingResolve = null;
        }

        return new Promise((resolve) => {
            this.#pendingResolve = resolve;
            dialog.showModal();
            cancelBtn.focus();
        });
    }

    #resolve(value) {
        if (this.#pendingResolve) {
            this.#pendingResolve(value);
            this.#pendingResolve = null;
        }
    }
}

customElements.define('admin-confirm-dialog', ConfirmDialogComponent);
